import React from "react";

export const getGeoDropdownOptions = (geos: string[]) =>
  geos.map((geo) => ({
    value: geo,
    label: geo,
    icon:
      geo.toLowerCase() === "ww" ? (
        <span className="geo-dropdown__world-icon">🌎</span>
      ) : undefined,
    img:
      geo.toLowerCase() === "ww"
        ? undefined
        : `https://flagcdn.com/w40/${geo.toLowerCase()}.png`,
  }));
